module.exports = __webpack_public_path__ + "static/case1_allergy_mobile-3885da50a86f3425d06c91f8682c9fef.png";